import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/main.css'
import './assets/common.css'
import axios from 'axios'
import { Loading } from 'element-ui'
import store from './store'
// excel导出
import Blob from '@/vendor/Blob'
import Export2Excel from '@/vendor/Export2Excel'
Vue.use(ElementUI)
Vue.prototype.$ajax = axios
Vue.config.productionTip = false
// let loading;

// 仅在开发环境中引入 Mock 数据
console.log('process.env.NODE_ENV: ', process.env.NODE_ENV)
if (process.env.NODE_ENV === 'development') {
  require('./mock')
}

// 添加响应拦截器
let unhasSession = false

axios.defaults.withCredentials = false
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8' //配置请求头
//添加一个请求拦截器
axios.interceptors.request.use(
  function (config) {
    let token = window.localStorage.getItem('admin_token')
    if (token) config.headers.common['token'] = token
    let admin_id = window.localStorage.getItem('admin_id')
    if (admin_id) config.headers.common['uid'] = admin_id
    return config
  },
  function (error) {
    return Promise.reject(error)
  },
)
axios.interceptors.response.use(
  function (response) {
    if (!response.data.success) {
      let data = response.data.data
      console.log(data)
      if ((data && data.code && data.code == 1001) || (data && data.code && data.code == 1002)) {
        if (!unhasSession) {
          //防止重复执行
          ElementUI.Message({
            message: '登录已过期，请重新登录',
            type: 'warning',
          })
          window.localStorage.clear()
          router.replace({
            name: 'login',
          })
          unhasSession = true
        }
      } else {
        ElementUI.Message({
          message: response.data.msg,
          type: 'error',
        })
      }
    }
    return response
  },
  function (error) {
    return Promise.reject(error)
  },
)

new Vue({
  el: '#app',
  router,
  store,
  render: (h) => h(App),
})



// WEBPACK FOOTER //
// ./src/main.js